import script from "./AdminSidebarCollapsed.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSidebarCollapsed.vue?vue&type=script&setup=true&lang=js"

import "./AdminSidebarCollapsed.vue?vue&type=style&index=0&id=26fa3560&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26fa3560"]])

export default __exports__